var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loader",class:_vm.ifLoading},[_c('TheSpinner')],1),(_vm.loading)?_c('div',{staticClass:"px-3 max-w-3xl m-auto my-5 leading-relaxed"},[_c('the-text-view',{attrs:{"value":_vm.items[1].content}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }